import { useDataContext, usePageContext } from "../context";
import { useLazyReadMultipleQuery, useLazyReadQuery } from "../../../services/data/tableDataApi";

import { FetchStatus } from "../../../base/types";
import { IFilterGroup } from "../../../data";
import { getQueryFields } from "../../helpers";
import { useAuth } from "../../../../modules/auth";

export const useResetData = () => {
    const { page, pageView } = usePageContext()
    const { user, siteId } = useAuth()
    const [readRecord] = useLazyReadQuery();
    const [readRecords] = useLazyReadMultipleQuery();
    const { setData } = useDataContext()

    const reset = () => {
        if (!page) return;
        if (!user || !siteId) return;

        const { userId } = user;
        const { sourceObject: entity } = page;

        if (!entity) return;

        setData({ type: "Static", status: FetchStatus.Loading })
        const fieldList = getQueryFields(page.controls || [], page.actions || [], page.filters || []);
        if (pageView?.systemId) {
            readRecord({ userId, portalId: siteId, tableId: entity, sysId: pageView?.systemId, fieldList })
                .unwrap()
                .then(data => {
                    setData({ type: "Card", result: data, status: FetchStatus.Success })
                })
                .catch(err => {
                    const error = err.data?.error?.message || 'Failed to get data'
                    setData({ type: "Static", status: FetchStatus.Error, error })
                })
        } else {
            const filters: IFilterGroup[] = [];
            if (page.filters)
                filters.push({ group: 0, filters: page.filters });
            if (pageView?.linkFilters)
                filters.push({ group: 2, filters: pageView?.linkFilters });
            if (pageView?.viewFilters)
                filters.push({ group: 3, filters: pageView?.viewFilters });

            readRecords({ userId, portalId: siteId, tableId: entity, fieldList, recordLimit: 1, filters })
                .unwrap()
                .then(data => {
                    const records = data?.records || [];
                    const record = Array.isArray(records) ? (records[0] || undefined) : records;
                    setData({ type: "Card", result: record, status: FetchStatus.Success })
                })
                .catch(err => {
                    const error = err.data?.error?.message || 'Failed to get data'
                    setData({ type: "Static", status: FetchStatus.Error, error })
                })
        }
    }

    return { reset }
}